/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Equipment_Group_Free_WeightsInputs */

const en_us2_equipment_group_free_weights = /** @type {(inputs: Equipment_Group_Free_WeightsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free weights`)
};

const pt_br2_equipment_group_free_weights = /** @type {(inputs: Equipment_Group_Free_WeightsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pesos livres`)
};

const es_419_equipment_group_free_weights = /** @type {(inputs: Equipment_Group_Free_WeightsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pesos libres`)
};

const pt_pt2_equipment_group_free_weights = /** @type {(inputs: Equipment_Group_Free_WeightsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pesos livres`)
};

const fr_fr2_equipment_group_free_weights = /** @type {(inputs: Equipment_Group_Free_WeightsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poids libres`)
};

const de_de2_equipment_group_free_weights = /** @type {(inputs: Equipment_Group_Free_WeightsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Freie Gewichte`)
};

const it_it2_equipment_group_free_weights = /** @type {(inputs: Equipment_Group_Free_WeightsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pesi liberi`)
};

/**
* | output |
* | --- |
* | "Free weights" |
*
* @param {Equipment_Group_Free_WeightsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const equipment_group_free_weights = /** @type {((inputs?: Equipment_Group_Free_WeightsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Equipment_Group_Free_WeightsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_equipment_group_free_weights(inputs)
	if (locale === "es-419") return es_419_equipment_group_free_weights(inputs)
	if (locale === "pt-PT") return pt_pt2_equipment_group_free_weights(inputs)
	if (locale === "fr-FR") return fr_fr2_equipment_group_free_weights(inputs)
	if (locale === "de-DE") return de_de2_equipment_group_free_weights(inputs)
	if (locale === "it-IT") return it_it2_equipment_group_free_weights(inputs)
	return en_us2_equipment_group_free_weights(inputs)
});
export { equipment_group_free_weights as "equipment.group.free_weights" }